import React from 'react'
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

const PrivateRoute = () => {
  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated)
  const location = useLocation()

  if (typeof isAuthenticated === 'undefined') {
    return null
  }

  if (isAuthenticated) {
    return <Outlet />
  } else {
    // ✅ Store intended route
    sessionStorage.setItem("redirectAfterLogin", location.pathname)
    console.log(sessionStorage.getItem("redirectAfterLogin"));
    return <Navigate to="/sign-in" replace />
  }
}

export default PrivateRoute